require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./union-county-pre-sentencing-assessment.json") })
        }
      }, "path---union-county-pre-sentencing-assessment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---union-county-pre-sentencing-assessment!./.cache/json/union-county-pre-sentencing-assessment.json
// module id = 1062
// module chunks = 231608221292675